export const trimString = (value: string) => {
  return value.replace(/\s+/g, ' ').trim();
};

export const parsingSpecialCharacters = (str: string) => {
  const regex = /[^а-яА-ЯёЁa-zA-Z\-\s]/g;
  return Array.from(new Set(str.match(regex))).join();
};
